@let breadcrumbs = breadcrumbs$ | async;
@if (breadcrumbs && breadcrumbs.length) {
  <div class="flex gap-10 pt-20 px-60">
    @for (breadcrumb of breadcrumbs; track $index; let last = $last) {
      <a [routerLink]="breadcrumb.link" [class.active]="last">
        {{ breadcrumb.label }}</a
      >
      @if (!last) {
        <span> > </span>
      }
    }
  </div>
}
